import { FC, useState } from 'react';
import cls from 'clsx';
import { Globe } from '@linktivity/link-icons';
import { Dropdown } from '@linktivity/link-ui';
import { setLocale } from '@triplabo/web/i18n';

import styles from './languageSelector.module.css';

const languageOptions = [
  { code: 'en', name: 'English' },
  { code: 'zh', name: '简体中文' },
  { code: 'zt', name: '繁體中文' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' }
];

const LanguageSelector: FC<{ iconClass?: string }> = ({ iconClass }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLanguageChange = (locale: string) => {
    setLocale(locale);
    setIsDropdownOpen(false);
  };

  return (
    <Dropdown
      target={
        <button
          className={styles.globeButton}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <Globe className={cls(styles.globeIcon, iconClass)} />
        </button>
      }
      visible={isDropdownOpen}
      sameWidth={false}
      placement="bottom-end"
      onClose={() => setIsDropdownOpen(false)}
    >
      <Dropdown.Menu className={styles.dropdownMenu}>
        {languageOptions.map(option => (
          <Dropdown.Item key={option.code}>
            <button
              key={option.code}
              className={styles.dropdownItem}
              onClick={() => handleLanguageChange(option.code)}
            >
              {option.name}
            </button>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector;
